import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-senior-citizen-transaction',
  templateUrl: './senior-citizen-transaction.component.html',
  styleUrls: ['./senior-citizen-transaction.component.css']
})
export class SeniorCitizenTransactionComponent implements OnInit {
  status : string;
  transactionFailure:boolean = false;

  constructor() { }

  ngOnInit() {
    this.getStatus();
  }

  getStatus() {
    this.status = location.pathname.split('/')[3];
    if(this.status == 'true') {
      this.transactionFailure = false;
    } else {
      this.transactionFailure = true;
    }

    console.log(status);
  }
}
